import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, RepeatableSummary, Step } from '../SteppedForm';

const StepVehicles = (props) => {
  return (
    <Step
      id="vehiclesummary"
      title="Vehicles"
      skip={(formdata) => formdata.onboardcar === false || formdata.tiger}
      nonext>
      <RepeatableSummary
        jumpTo={(idx) =>
          props.setState({ vehicle_index: idx }, () => props.jumpTo('onboardvehicle'))
        }
        getRow={(data) =>
          data.carbuy
            ? {
                VIN: 'Provided by ' + props.state.formdata.network,
                [props.stateconfig().plateName || props.stateconfig().authName]:
                  data.plate_number || data.auth_number,
                Make: '',
                Model: ''
              }
            : {
                VIN: data.vin,
                [props.stateconfig().plateName || props.stateconfig().authName]:
                  data.plate_number || data.auth_number,
                Make: data.make === 'Other' ? data.makeother : data.make,
                Model:
                  data.model === 'Other' || data.make === 'Other' ? data.modelother : data.model
              }
        }
        getName={(vehicle) => {
          if (!vehicle.make) return 'Provided by ' + props.state.formdata.network;
          return vehicle.make + ' ' + vehicle.model + ', ' + vehicle.rego;
        }}
        canDelete={(i) => props.state.formdata.vehicles.length > 1}
      />
      <Typography variant="body1" class="formQuestion">
        Do you have more vehicles to onboard?
      </Typography>
      <ButtonField
        onClick={() => {
          props.setState(
            {
              formdata: {
                ...props.state.formdata,
                vehicles: [...props.state.formdata.vehicles, {}]
              },
              vehicle_index: props.state.formdata.vehicles.length
            },
            () => props.jumpTo('onboardvehicle')
          );
        }}
        label="Yes"
        className="TopIconButton"
        startIcon={<CheckOutlinedIcon />}
      />
      <ButtonField label="No" className="TopIconButton" startIcon={<ClearOutlinedIcon />} />
    </Step>
  );
};

export default StepVehicles;
